import React from "react";
import {useLoginContext} from "./Login";
import LoginSecure1 from "./LoginSecure1";
import LoginSecure2 from "./LoginSecure2";

export default function LoginSecure() {
    const {preSessionState} = useLoginContext();
    return preSessionState.secureLogin?.userIdentifierType ? <LoginSecure2 /> : <LoginSecure1 />;
}
